<template>
  <v-card outlined class="fill-height d-flex flex-column">
    <v-card-title class="text-subtitle-1 font-weight-bold">{{
      $t('distribution.directLink.title')
    }}</v-card-title>
    <v-card
      class="mx-4 flat flex-grow-1 d-flex flex-column"
      color="blue-grey lighten-5"
      flat
      rounded="lg"
    >
      <v-card-text class="pb-2">{{
        $t('distribution.directLink.description')
      }}</v-card-text>
      <div
        class="pt-0 pb-4 pl-4 text-h5 font-weight-bold flex-grow-1 d-flex align-center"
        color="black"
      >
        {{ directUrl }}
      </div>
    </v-card>
    <v-card-actions class="px-4 py-3">
      <v-btn
        block
        depressed
        outlined
        color="blue-grey darken-5"
        @click="copyDirectLink"
        :disabled="!classCode"
      >
        <v-icon class="mr-2" size="medium">mdi-content-copy</v-icon>
        {{ $t('distribution.directLink.buttonText') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import {
  copyToClipboard,
  getDistributionUrl,
  getDistributionUrlWithoutProtocol,
} from "@/utils/distributionUtils";

export default defineComponent({
  name: "DirectLink",
  props: {
    classCode: {
      type: String,
      default: null,
    },
  },
  computed: {
    directUrl(): string {
      if (!this.classCode) {
        return "-";
      }
      return getDistributionUrlWithoutProtocol(this.classCode);
    },
  },
  methods: {
    async copyDirectLink() {
      if (!this.classCode) {
        return;
      }

      const fullUrl = getDistributionUrl(this.classCode);
      await copyToClipboard(
        fullUrl,
        this.$t("distribution.directLink.copySuccess") as string,
        this.$t("distribution.directLink.copyError") as string,
        this.$root.$emit.bind(this.$root),
      );
    },
  },
});
</script>
